<template>
 <Tooltip :content="content" :disabled="!permissao" className="notificao" :style="`width: ${width}`">
   <slot v-if="isVisible"></slot>
 </Tooltip>
</template>

<script>
export default {
  name: 'NotificaoPermissao',
  props: {
    permissao: {
      type: Boolean,
      default: () => false
    },
    content: {
      type: String,
      default: () => 'Você não tem permissão para essa ação.'
    },
    isVisible: {
      type: Boolean,
      default: () => true
    },
    width: {
      type: String || Number,
      default: () => '100%'
    }
  }
};
</script>

<style lang="less" scoped>

</style>
